'use client';

import Link from 'next/link';

import { LEAD_FORM_NAME } from '@/features/lead-form/constants/formName';
import { LEAD_TYPE } from '@/features/lead-form/constants/leadType';
import { Form, FORM_KEY } from '@publishing/modules/forms';

import s from '../ff-partners.module.scss';

import { GTM_EVENT } from '@/shared/constants/gtm';
import { gtmClick } from '@/shared/utils/gtm';

export function FfPartnersWelcome() {
  return (
    <main className={`${s.welcome_contact} h_full`}>
      <div className={s.inner}>
        <header className={s.contact_header}>
          <h1 className={s.title_h1}>사무실 문의하기</h1>

          <p className={s.text_p1}>
            지인에게 패파를 추천 받으셨다면
            <br />
            우리 기업의 정보를 등록해 주세요.
            <br />
            이 폼을 통해 등록하고 투어를 진행하시면
            <br />
            가벼운 리워드가 제공됩니다.
          </p>

          <p className={s.text_box}>
            패파 서비스가 궁금하시다면,{' '}
            <Link
              href="/ff-partners"
              className="ga4__cta_btn_link"
              {...gtmClick(GTM_EVENT.BTN, '여기', '/ff-partners')}
            >
              여기
            </Link>
            에서 더 알아보세요.
          </p>

          <div className={s.img_area} aria-hidden="true" />
        </header>

        <section className={s['contact-box']} aria-label="사무실 문의 신청">
          <div className={s['form-box']}>
            <Form
              type={FORM_KEY.SHARED_OFFICE}
              formName={LEAD_FORM_NAME.AFFILIATE}
              leadType={[LEAD_TYPE.SHARED_OFFICE]}
              showTip={false}
              submitLabel="문의 등록하기"
              className={s.lead_form}
              actionAreaClassName={s.lead_form_actions}
            />
          </div>
        </section>
      </div>
    </main>
  );
}
